import { FilterType } from '../@types/Filters';
export const Getters = {
    getFilters(state) {
        return typeof state.filters == 'object' && !Array.isArray(state.filters)
          ? Object.values(state.filters)
          : state.filters
    },
    hasActiveFilters(state) {
        return Getters.getFilters(state).filter(filter => {
            return filter.hasOwnProperty('active') && filter.active
        }).length > 0
    },
    //ensures that there is only ever one of a single filter
    filter: (state) => (payload) => {
        const filter = Getters.getFilters(state).filter(filter => {
          return filter.type === payload.type && filter.handle == payload.handle
            // if (payload.type === filter.type) {
            //     if (payload.type === FilterType.Meta) {
            //         return payload.handle === filter.handle
            //     } else if (payload.type === FilterType.Taxonomy) {
            //         return payload.taxonomy === filter.taxonomy
            //     } else {
            //         return false
            //     }
            // } else {
            //     return false
            // }            
        })
        
        return filter.length === 0 ? false : filter[0]
    },
    getRegions(state) {
      return typeof state.regions != 'undefined' ? state.regions : [];
    },
    getProducts(state) {
        return typeof state.products != 'undefined' ? state.products : [];
    },
    getElement: (state) => (el) => {
        return state.elements.find(el);
    },
    getElements(state) {
        return typeof state.elements != 'undefined' ? state.elements : [];
    },
    categories(state) {
        return state.categories == null ? []: state.categories;
    },
    isUpdatingProducts(state) {
        return typeof state.isUpdatingProducts != 'undefined' ? state.isUpdatingProducts : false;
    },
    isUpdated(state) {
        return !state.isUpdatingProducts && !state.searchUpdateNeeded
    },
    attributes(state) {
        return state.attributes;
    },
    attributeTerms(state) {
        return state.attributeTerms;
    },
    timePassed : (state) => {
        return state.timePassed;
    },
    timeLimit: (state) => {
        return state.timeLimit
    },
    timeLeft: (state) => {
        return state.timeLimit - state.timePassed
    },
    getCurrentCategoryFilter(state) {
      let categories = state.filters.filter(filter => {
        return filter.type === FilterType.Taxonomy && filter.handle === 'category'
      })

      return categories.length > 0 ? categories[0]: false
    },
    getParent(state) {
      let possibleParent = state.filters.filter(filter => {
        return filter.type === FilterType.Meta && filter.handle === 'parent'
      })

      return possibleParent.length > 0 ? possibleParent[0].value : false
    },
    getSampleOptions(state) {
      return state.sampleOptions
    },
    getPages(state) {
      return typeof state.max_num_pages != 'undefined' ? state.max_num_pages: 1
    },
    getCurrentPage(state) {
      return state.current_page
    },
    getResultsCount(state) {
      return state.post_count
    },
    getLang(state) {
      return state.lang
    }
};